(function($) {
  
    $(document).ready(function() {

        
    });
    
  })(jQuery);

function initSearchformArchive(){
    var $ = jQuery;
    $('.l-container').on('load-more-pagination-before-insert', '#search-results .l-4-equal-columns, #search-results .l-5-equal-columns', function() {
        $(this).find('.m-card-empty').remove();
    });

    $('.searchform-archive-element.is-date input').on('apply.daterangepicker', function(ev, picker) {
        $(this).val(picker.startDate.format(objectL10n.format) + ' <> ' + picker.endDate.format(objectL10n.format)).trigger('change');
    });

    $('.searchform-archive-element.is-date input').daterangepicker({
        autoUpdateInput: false,
        locale: {
            "format": objectL10n.format,
            "separator": objectL10n.separator,
            "applyLabel": objectL10n.applyLabel,
            "cancelLabel": objectL10n.cancelLabel,
            "fromLabel": objectL10n.fromLabel,
            "toLabel": objectL10n.toLabel,
            "customRangeLabel": objectL10n.customRangeLabel,
            "weekLabel": "S",
            "daysOfWeek": [
                objectL10n.dayShortDim,
                objectL10n.dayShortLun,
                objectL10n.dayShortMar,
                objectL10n.dayShortMer,
                objectL10n.dayShortJeu,
                objectL10n.dayShortVen,
                objectL10n.dayShortSam
            ],
            "monthNames": [
                objectL10n.monthLongJan,
                objectL10n.monthLongFev,
                objectL10n.monthLongMar,
                objectL10n.monthLongAvr,
                objectL10n.monthLongMai,
                objectL10n.monthLongJun,
                objectL10n.monthLongJui,
                objectL10n.monthLongAou,
                objectL10n.monthLongSep,
                objectL10n.monthLongOct,
                objectL10n.monthLongNov,
                objectL10n.monthLongDec
            ],
            "firstDay": 1,
        },
    });
    if($('.searchform-archive-element.is-date input').length){
        window.setInterval(function(){
            $('.applyBtn').prop('disabled',false);
        },100)
        $('.js').on('click','.applyBtn',function(e){
            if($(".start-date").length && !$(".end-date").length){
                var month = $(".start-date").parent().parent().parent().find(".month").html();
                var date = $(".start-date").html();
                month = month.replace(objectL10n.monthLongJan+' ','/01/');
                month = month.replace(objectL10n.monthLongFev+' ','/02/');
                month = month.replace(objectL10n.monthLongMar+' ','/03/');
                month = month.replace(objectL10n.monthLongAvr+' ','/04/');
                month = month.replace(objectL10n.monthLongMai+' ','/05/');
                month = month.replace(objectL10n.monthLongJun+' ','/06/');
                month = month.replace(objectL10n.monthLongJui+' ','/07/');
                month = month.replace(objectL10n.monthLongAou+' ','/08/');
                month = month.replace(objectL10n.monthLongSep+' ','/09/');
                month = month.replace(objectL10n.monthLongOct+' ','/10/');
                month = month.replace(objectL10n.monthLongNov+' ','/11/');
                month = month.replace(objectL10n.monthLongDec+' ','/12/');
                if(date<10){date = '0'+date;}
                $('.searchform-archive-element.is-date input').val(date+month+' - '+date+month);
            }
            e.preventDefault();
            return false;
        })
    }

    $('.m-searchform-archive select:not(.is-single)').multipleSelect({
        placeholder: objectL10n.placeholder,
        formatNoMatchesFound : function() {return objectL10n.noMatchesFound},
        filter: true,
        selectAll: false,
        formatCountSelected: '# '+objectL10n.choix,
        //isOpen: true,
        //keepOpen: true
        onClick: function(view) {
            $('.m-searchform-archive select').each(function(){
                //console.log($(this).multipleSelect('getSelects').length);
                if($(this).multipleSelect('getSelects').length){
                    $(this).parent().find('.ms-parent .ms-choice div').html('<div class="count">'+$(this).multipleSelect('getSelects').length+'</div>')
                }else{
                    $(this).parent().find('.ms-parent .ms-choice div').html('')
                }
            })
        },
        onFocus: function(view){
            $(this).parent().removeClass('is-open');
        },
        onBlur: function(view){
            $(this).parent().addClass('is-open');
        }
    })
    $('.m-searchform-archive select.is-single').multipleSelect({
        single:true,
        placeholder: objectL10n.placeholder,
        noMatchesFound : objectL10n.noMatchesFound,
        filter: true,
        selectAll: false,
        formatCountSelected: function(count, total) {
            return count+' '+objectL10n.choix;
        },
        //isOpen: true,
        //keepOpen: true
        onClick: function(view) {
            $('.m-searchform-archive select').each(function(){
                //console.log($(this).multipleSelect('getSelects').length);
                if($(this).multipleSelect('getSelects').length){
                    $(this).parent().find('.ms-parent .ms-choice div').html('<div class="count">'+$(this).multipleSelect('getSelects').length+'</div>')
                }else{
                    $(this).parent().find('.ms-parent .ms-choice div').html('')
                }
            })
        },
        onFocus: function(view){
            $(this).parent().removeClass('is-open');
        },
        onBlur: function(view){
            $(this).parent().addClass('is-open');
        }
    })

    $('.js-redirect-on-select').on('change',function(){
        if ($(this).find(":selected").length) {
            var memberID = $(this).find(":selected").attr('value');
            //console.log(memberID);
            window.location.replace("/?p="+memberID);
        }
    })
    
    $('.m-searchform-archive select').each(function(){
        if($(this).find(":selected").length){
            $(this).parent().find('.ms-parent .ms-choice div').html('<div class="count">'+$(this).find(":selected").length+'</div>')
        }else{
            $(this).parent().find('.ms-parent .ms-choice div').html('')
        }
    })

    $('.m-searchform-archive').on('keydown','input',function(){
        var inputVar = $(this);
        window.setTimeout(function(){
            inputVar.parent().attr("data-space",inputVar.val())
        },50)
    })

    $('.js-reset').on('click',function(){
        $('.m-searchform-archive input').val('');
        $('.m-searchform-archive select option').prop("selected", false);
        $('.m-searchform-archive select').multipleSelect('refresh');
        $('.ms-parent .ms-choice >div').html('');
        return false;
    })
    /*$('.m-searchform-archive input').val('');
    $('.m-searchform-archive select option').prop("selected", false);
    $('.m-searchform-archive select').multipleSelect('refresh');*/

    $('.searchform-opener').click(function(){
        $('.m-searchform-archive').toggleClass('is-searchform-open')
    })

}